export const InvalidLink: React.FC = () => {
  return (
    <div className="pageContainer balloons-bg errorPage">
      <div className="balloon balloon--green">
        <img src="./img/fc-balloon-green-gold.svg" alt="" />
      </div>
      <div className="balloon balloon--orange">
        <img src="./img/fc-balloon-orange-cream.webp" alt="" />
      </div>
      <div className="balloon balloon--cream">
        <img src="./img/fc-balloon-cream-red.svg" alt="" />
      </div>
      <div className="balloon balloon--purple">
        <img src="./img/fc-balloon-purple-pink.svg" alt="" />
      </div>
      <div className="logoContainer">
        <img src={"./img/fc-logo.svg"} width="125px" alt="Flight Club" />
      </div>
      <div className="contentCard-outer">
        <div className="contentCard">
          <div className="errorContainer">
            <img src="./img/error-text.svg" alt="Error" />
            <div className="errorText">
              Invalid Link - Please use the touchscreen or talk to a host in venue
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
